export const STOCK_NOTIFICATION_TYPE = "stock";
export const PREMIUM_RECIPIENTS_TYPE = "premium";
export const NOTIFICATION_MESSAGE_MAX_LENGTH = 100000;
export const NOTIFICATION_MESSAGE_SHORT_MAX_LENGTH = 100;
